import { useState } from 'react';
import { usePropertyContacts } from '../../api/contacts.ts';
import { ContactLinkList } from './ContactLinkList.tsx';
import { AddContactSheet } from './AddContactSheet.tsx';
import { secondary } from './Sheet.tsx';

/**
 * A property's people (contacts module): management, the superintendent, an appraiser or broker (court
 * appointed where so), the utility account holder, vendors. Read by anyone who may read the property;
 * added by those who may record property work (tiers 1-2). An account number shows whole to property and
 * finance readers only.
 */
export function PropertyContacts({ propertyId }: { propertyId: string }) {
  const q = usePropertyContacts(propertyId);
  const [adding, setAdding] = useState(false);
  return (
    <section className="border-t border-neutral-200 pt-3">
      <div className="flex items-center gap-2">
        <h3 className="flex-1 text-xs font-bold tracking-[0.1em] text-neutral-500 uppercase">Contacts</h3>
        {q.data?.may_add && <button type="button" className={secondary} onClick={() => setAdding(true)}>Add a contact</button>}
      </div>
      {q.error ? (
        <p className="text-sm text-neutral-700">{q.error.message}</p>
      ) : !q.data ? (
        <p className="text-sm text-neutral-600">Loading…</p>
      ) : (
        <div className="text-sm">
          <ContactLinkList links={q.data.contacts} empty="No contacts are recorded for this property." />
        </div>
      )}
      {adding && <AddContactSheet target={{ property_id: propertyId }} onClose={() => setAdding(false)} />}
    </section>
  );
}
